import Icon from '../components/Icon.vue'

Icon.register({
  broom: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M256.5 216.8L343.2 325.9S326.6 428.3 266.6 476.1C206.7 523.9 0 510.2 0 510.2S3.8 487.1 11 454.8L105.6 342.6C109.6 337.9 104.8 331 99 333.1L38.6 355.2C53 313.5 71.3 275.1 93.2 257.7 153.1 209.9 256.5 216.8 256.5 216.8zM636.5 31L616.7 6C611.2-0.9 601.1-2 594.3 3.5L361.8 181.3 327.6 138.3C322.6 131.9 312.5 133.1 309.1 140.5L283.7 195.1 370.5 304.2 429.3 291.8C437.3 290.1 440.7 280.6 435.6 274.2L401.5 231.3 634 53.5C640.9 48 642 37.9 636.5 31z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/broom.js
// module id = zXC0
// module chunks = 144